<template>
    <div>
        <files-selector
            v-model="files"
            :uploading="uploading"
            @upload="onUpload"
        ></files-selector>
    </div>
</template>

<script>
  import FilesSelector from './FilesSelector.vue';
  import { uploadUserPrivateFiles } from '../../platform/files/services/fileService';

  export default {
    name: 'UserPrivateFilesUploader',
    components: { FilesSelector },
    data() {
      return {
        files: [],
        uploading: false,
      };
    },
    methods: {
        async onUpload() {
            try {
                if (!this.files.length) {
                    return;
                }
                this.uploading = true;
                const formData = new FormData();
                for (let index = 0; index < this.files.length; index++) {
                    formData.append(`file${index}`, this.files[index]);
                }
                const response = await uploadUserPrivateFiles(formData);
                // Preserving the old behavior:
                this.$emit('uploadedFileNames', response.result);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.uploading = false;
            }
        }
    }
  }
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/files/UserPrivateFilesUploader.vue